import { render } from "./ReferenceInfoHistoryTable.vue?vue&type=template&id=754e5255&scoped=true"
import script from "./ReferenceInfoHistoryTable.vue?vue&type=script&lang=js"
export * from "./ReferenceInfoHistoryTable.vue?vue&type=script&lang=js"

import "./ReferenceInfoHistoryTable.vue?vue&type=style&index=0&id=754e5255&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754e5255"]])

export default __exports__